const getDefaultCountryCode = (codes: string | undefined): string => {
  const split: string[] | undefined = codes?.split(",");
  return split?.length ? split[0] : "";
};

export default getDefaultCountryCode;
